import { Collapse, Flex } from 'antd';

const responseSuccess = {
    data: [
        {
            pricings: [
                {
                    id: 43987063,
                    price: 250000,
                    cycles: {
                        unit: 'months',
                        value: 1,
                        display_name: '1 Tháng',
                    },
                },
                {
                    id: 14935556,
                    price: 675000,
                    cycles: {
                        unit: 'months',
                        value: 3,
                        display_name: '3 Tháng',
                    },
                },
                '...',
            ],
            cloud_server: [
                {
                    pricings: [
                        {
                            id: 81369683,
                            price: 140000,
                            cycles: {
                                unit: 'months',
                                value: 1,
                                display_name: '1 Tháng',
                            },
                        },
                        '...',
                    ],
                    id: 32483388,
                    core: 2,
                    disk: 40,
                    ipv4: 1,
                    ipv6: 0,
                    title: 'Premium #3',
                    commit: 'Online 99.99%',
                    status: true,
                    memory: 2048,
                    support: '24/7',
                    priority: 3,
                    sold_out: false,
                    disk_info: 'NVME',
                    core_info: 'Xeon Gold 6133',
                    bandwidth: 0,
                    memory_info: 'DDR4 ECC',
                    network_port: 10,
                    network_speed: 200,
                    network_inter: 10,
                },
                '...',
            ],
            id: 23176528,
            title: 'Web clone trang nạp thẻ của Garena',
            modules: [
                {
                    modun: 'Người dùng',
                    content: 'Đầy đủ chức năng như trang napthe.vn cho game Free Fire',
                    include: true,
                    description: ['Đăng nhập game Free Fire bằng ID người chơi', 'Chọn các loại thẻ và mệnh giá có thể nạp', '...'],
                },
                {
                    modun: 'Quản trị website',
                    content: 'Quản trị website thống kê, thay đổi cấu hình website',
                    include: true,
                    description: ['Thống kê thẻ nạp hàng ngày', 'Quản lí các loại thẻ có thể nạp và chỉnh sửa', '...'],
                },
            ],
            version: '1.0.0',
            slug_url: 'web-clone-trang-nap-the-cua-garena',
            priority: 2,
            demo_url: 'https://napkimcuongfreefire.vn',
            image_url: 'https://thegioicode.com/images/QYfMisvokf.png',
            image_meta: ['https://thegioicode.com/images/LXvLVoKsLb.png', 'https://thegioicode.com/images/JCfDwITxXG.png', '...'],
            description:
                'Web clone nạp thẻ napthe.vn của Garena - Sử dụng API của hệ thống chúng tôi kiểm tra ID người chơi hợp hệ hay không',
        },
    ],
    status: 200,
    message: 'Lấy danh sách mẫu website thành công',
};

function GetList() {
    return (
        <Collapse
            items={[
                {
                    key: '1',
                    label: <div className="font-bold text-hover">Danh sách mẫu website</div>,
                    children: (
                        <div>
                            <Flex align="center">
                                <span className="document-method text-success font-bold">GET</span>
                                <span className="document-method flex-1 text-start">https://thegioicode.com/api/v2/templates</span>
                            </Flex>

                            <div className="mt-3 mb-1">Thành công:</div>
                            <div>
                                <div className="copy">
                                    <pre>
                                        <code className="text-copy success">{JSON.stringify(responseSuccess, null, 2)}</code>
                                    </pre>
                                </div>
                            </div>

                            <div className="mt-3 mb-1">Thất bại:</div>
                            <div>
                                <div className="copy">
                                    <pre>
                                        <code className="text-copy">
                                            {JSON.stringify({ status: 'Mã code lỗi', error: 'Thông tin lỗi trả về' }, null, 4)}
                                        </code>
                                    </pre>
                                </div>
                            </div>
                        </div>
                    ),
                },
            ]}
        />
    );
}

export default GetList;
